module.exports = __webpack_public_path__ + "img/team-6.09de0e86.jpg";